import helpService from '../services/helpService';

/**
 * Submit contact form
 * @param {Object} contactData - Contact form data
 * @param {string} contactData.name - User's name
 * @param {string} contactData.email - User's email
 * @param {string} contactData.reason - Feedback reason
 * @param {string} contactData.subject - Subject of the message
 * @param {string} contactData.message - Message content
 * @param {string} contactData.file - Comma-separated file keys (optional)
 * @returns {Promise<Object>} Promise that resolves to response object
 */
export const submitContactForm = async (contactData) => {
    try {
        const response = await helpService.submitContactForm(contactData);
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, error: response.message };
        }
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * Report a content creator for impersonation
 * @param {string} creatorId - ID of the creator being reported
 * @param {Object} reportData - Report data
 * @param {string} reportData.reason - Reason for the report
 * @param {string} reportData.account_linked - Username of the account being impersonated
 * @returns {Promise<Object>} Promise that resolves to response object
 */
export const reportContentCreator = async (creatorId, reportData) => {
    try {
        const response = await helpService.reportContentCreator(creatorId, reportData);
        if (response.success) {
            return { success: true, data: response.data, status: response.status };
        } else {
            return { success: false, error: response.message, status: response.status };
        }
    } catch (error) {
        return { success: false, error: error.message };
    }
};
